import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService, { type UpdateConfigurationRequest } from '../services/capitalMarketsService';

const QUERY_KEY = ['configuration'];

export function useConfiguration() {
  return useQuery({
    queryFn: () => capitalMarketsService.getConfiguration(),
    queryKey: QUERY_KEY,
    staleTime: 30_000,
  });
}

export function useUpdateConfiguration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateConfigurationRequest) => capitalMarketsService.updateConfiguration(data),
    onError: () => {
      toast.error('Erro ao atualizar configurações');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
      toast.success('Configurações atualizadas com sucesso');
    },
  });
}
